module.exports = __webpack_public_path__ + "static/img/c2_2.e5e56c7b.png";